import { createFileRoute } from "@tanstack/react-router"
import { formsViewLayoutHandle } from "src/views/FormsView/constants"
import { FormsView } from "src/views/FormsView/FormsView"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/forms/")({
	component: FormsView,
	staticData: formsViewLayoutHandle,
})
